import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FileText, Landmark, Mail } from "lucide-react";

interface NotesCardProps {
  paymentNotes?: string;
  reasonForPurchase?: string;
  welcomeEmailNotes?: string;
}

export function NotesCard({ 
  paymentNotes, 
  reasonForPurchase, 
  welcomeEmailNotes 
}: NotesCardProps) {
  // Don't render if all fields are empty
  if (!paymentNotes && !reasonForPurchase && !welcomeEmailNotes) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Notes & Details</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="payment" className="w-full">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="payment" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              <span className="hidden sm:inline">Payment</span>
            </TabsTrigger>
            <TabsTrigger value="reason" className="flex items-center gap-2">
              <Landmark className="h-4 w-4" />
              <span className="hidden sm:inline">Reason</span>
            </TabsTrigger>
            <TabsTrigger value="welcome" className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <span className="hidden sm:inline">Welcome</span>
            </TabsTrigger>
          </TabsList>

          {/* Payment Details Tab */}
          <TabsContent value="payment" className="py-4">
            {paymentNotes ? (
              <div className="text-sm text-muted-foreground whitespace-pre-line p-4 bg-accent/50 rounded-lg">
                <div dangerouslySetInnerHTML={{ __html: paymentNotes }} />
              </div>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                No payment details available
              </div>
            )}
          </TabsContent>

          {/* Reason for Purchase Tab */}
          <TabsContent value="reason" className="py-4">
            {reasonForPurchase ? (
              <div className="prose max-w-none p-4 bg-muted/20 rounded-md">
                <div dangerouslySetInnerHTML={{ __html: reasonForPurchase }} />
              </div>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                No reason for purchase available
              </div>
            )}
          </TabsContent>

          {/* Welcome Email Notes Tab */}
          <TabsContent value="welcome" className="py-4">
            {welcomeEmailNotes ? (
              <div className="prose max-w-none p-4 bg-muted/20 rounded-md">
                <div dangerouslySetInnerHTML={{ __html: welcomeEmailNotes }} />
              </div>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                No offer email notes available
              </div>
            )}
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}

export default NotesCard;
